import { Component, Vue, Prop } from 'vue-property-decorator';
import { ShowingsRestfulDelegate } from '../../../../../services/DataDelegate/ShowingsDelegate/showings.restful.delegate';
import * as T_T from 'cryface';
import { IShowingDetail, IShowingLog } from '../../../../../models/showing';
import { formatDateTime } from '../../../../../utils/format.time';

@Component
export default class Detail extends Vue {
   public title: string = 'Detail';
   public showingRestFulDelegate = new ShowingsRestfulDelegate();

   @Prop()
   public row: any;

   public showingData: IShowingDetail = {
      id: -1,
      xName: '',
      xCustomerId: -1,
      xMlsNumber: '',
      xOpportunityId: -1,
      xPurposeId: -1,
      xShowingDate: '',
      xListingPrice: -1,
      xAddress: '',
      xSalespersonId: '',
      xRadarListingsId: '',
      xShowingAgentId: '',
      xType: '',
      xStatus: '',
      xReceiverName: '',
      xListingAgentId: '',
      listingAgent: undefined,
      showingAgent: undefined,
      radarListings: undefined,
      showingMessageList: undefined
   };

   public listingAgent = {
      id: '',
      Name: '',
      Mobile: '',
      Phone: '',
      CompanyName: '',
      Comment: '',
      Wechat: ''
   };

   public showingAgent = {
      id: '',
      Name: '',
      Mobile: '',
      Phone: '',
      CompanyName: '',
      Comment: '',
      Wechat: ''
   };

   public requestMessage = {
      id: -1,
      xContent: '',
      xMessageType: '',
      xOperatorId: '',
      xOperatorName: '',
      xShowingId: -1,
   };

   public notifiers: any[] = [];

   public message: string = '';

   public instruction: string = '';

   public lockbox: string = '';

   public showingLogs: IShowingLog[] = [];

   public timeLineMode: boolean = false;

   public prettyPrint(obj: any) {
      return T_T.simpleDetect(obj) ? JSON.stringify(obj) : '';
   }

   public async created() {
      await this._getListing();
      await this._getHistory();
   }

   private async _getListing() {
      const detailGotten = await this.showingRestFulDelegate.getShowingById(this.row.id);
      if (detailGotten !== 0) {
         this.showingData = detailGotten.data;
         if (T_T.simpleDetect(this.showingData.radarListings)) {
            this.instruction = T_T.simpleDetect(this.showingData.radarListings.xInstruction) ? this.showingData.radarListings.xInstruction : 'N/A';
            this.lockbox = T_T.simpleDetect(this.showingData.radarListings.xLockbox) ? this.showingData.radarListings.xLockbox : 'N/A';
            if (T_T.simpleDetect(this.showingData.radarListings.agentList)) {
               if (this.showingData.radarListings.agentList.length > 0) {
                  const listingAgentGotten = this.showingData.radarListings.agentList[0];
                  this.listingAgent.id = T_T.simpleDetect(listingAgentGotten.id) ? listingAgentGotten.id : -1;
                  this.listingAgent.Wechat = T_T.simpleDetect(listingAgentGotten.wechat) ? listingAgentGotten.wechat : 'N/A';
                  this.listingAgent.Name = T_T.simpleDetect(listingAgentGotten.name) ? listingAgentGotten.name : 'N/A';
                  this.listingAgent.Mobile = T_T.simpleDetect(listingAgentGotten.mobile) ? listingAgentGotten.mobile : 'N/A';
                  this.listingAgent.Phone = T_T.simpleDetect(listingAgentGotten.phone) ? listingAgentGotten.phone : 'N/A';
                  this.listingAgent.CompanyName = T_T.simpleDetect(listingAgentGotten.companyName) ? listingAgentGotten.companyName : 'N/A';
                  this.listingAgent.Comment = T_T.simpleDetect(listingAgentGotten.comment) ? listingAgentGotten.comment : 'N/A';
               }
               if (this.showingData.radarListings.notifiers.length > 0) {
                  const notifiers = this.showingData.radarListings.notifiers;
                  for (let i = 0; i < notifiers.length; i++) {
                     const firstName = T_T.simpleDetect(notifiers[i].xFirstname) ? notifiers[i].xFirstname : '';
                     const lastName = T_T.simpleDetect(notifiers[i].xLastname) ? notifiers[i].xLastname : '';
                     this.notifiers.push(
                        {
                           id: T_T.simpleDetect(notifiers[i].id) ? notifiers[i].id : -1,
                           Name: `${firstName} ${lastName}`,
                           Email: T_T.simpleDetect(notifiers[i].xEmail) ? notifiers[i].xEmail : 'N/A',
                           Phone: T_T.simpleDetect(notifiers[i].xPhone) ? notifiers[i].xPhone : 'N/A'
                        }
                     );
                  }
               }
            }
         }
         if (T_T.simpleDetect(this.showingData.showingAgent)) {
            const showingAgentGotten = this.showingData.showingAgent;
            this.showingAgent.id = T_T.simpleDetect(showingAgentGotten.id) ? showingAgentGotten.id : -1;
            this.showingAgent.Wechat = T_T.simpleDetect(showingAgentGotten.wechat) ? showingAgentGotten.wechat : 'N/A';
            this.showingAgent.Name = T_T.simpleDetect(showingAgentGotten.name) ? showingAgentGotten.name : 'N/A';
            this.showingAgent.Mobile = T_T.simpleDetect(showingAgentGotten.mobile) ? showingAgentGotten.mobile : 'N/A';
            this.showingAgent.Phone = T_T.simpleDetect(showingAgentGotten.phone) ? showingAgentGotten.phone : 'N/A';
            this.showingAgent.CompanyName = T_T.simpleDetect(showingAgentGotten.companyName) ? showingAgentGotten.companyName : 'N/A';
            this.showingAgent.Comment = T_T.simpleDetect(showingAgentGotten.comment) ? showingAgentGotten.comment : 'N/A';
         }
         if (T_T.simpleDetect(this.showingData.showingMessageList)) {
            if (this.showingData.showingMessageList.length > 0) {
               this.message = T_T.simpleDetect(this.showingData.showingMessageList[0].xContent) ? this.showingData.showingMessageList[0].xContent : 'N/A';
            }
         }
      }
   }

   private async _getHistory() {
      const historyLogsGotten = await this.showingRestFulDelegate.getHistory(this.row.id);
      this.showingLogs = historyLogsGotten.data;
   }

   private async saveNewLog() {}

   public formatDateTime(str: string) {
      return formatDateTime(str);
   }

   public destroyed() {
      this.showingRestFulDelegate.clearData();
   }
}
